import React, {useState} from 'react';
import {motion} from 'framer-motion';
import utils from "../../services/utils";
import IconProfile from '../../style/icons/profile-user.svg'
import managedata from "../../services/managedata";
import managecookies from "../../services/managecookies";

const GeneralProfile = ({userData}) => {
    const [step, setStep] = useState('edit');
    const [formData, setFormData] = useState({});
    const [fName, setFname] = useState(userData.privateName);
    const [lName, setLName] = useState(userData.lastName);
    const [phone, setPhone] = useState(userData.phone);
    const [newPhone, setNewPhone] = useState(userData.phone);
    const [pass, setPass] = useState('newpassword');
    const [newPass, setNewPass] = useState('newpassword');
    const [verificationCode, setVerificationCode] = useState('');
    const onSave = () => {
        if (newPhone === phone) updateAll()
        else {
            let phoneData = {
                authentication: {
                    key: utils.getToken(),
                    businessToken: utils.getBusToken(),
                },
                'data': {
                    "phone": newPhone, // the new phone number
                    "firstOrLastName": lName
                },
                'type': {'act': 'editMyPhone'}
            }
            managedata.sendData(phoneData)
            setStep('verify');
        }
    };

    const editLocalUser = (type) => {
        switch (type) {
            case 'name':
                userData.privateName = fName;
                userData.lastName = lName;
                break;
            case 'phone':
                userData.phone = newPhone;
                break;
        }
        managecookies.setCookie('userData', JSON.stringify(userData), 8)
        window.location.reload();
    }
    const updateAll = () => {
        let nameData = {
            authentication: {
                key: utils.getToken(),
                businessToken: utils.getBusToken(),
            },
            'data': {
                "privateName": fName,
                "lastName": lName,
            },
            'type': {'act': 'editMyName'}
        }
        managedata.sendData(nameData, false, editLocalUser('name'))
        if (newPass !== 'newpassword') {
            let passData = {
                authentication: {
                    key: utils.getToken(),
                    businessToken: utils.getBusToken(),
                },
                'data': {
                    "phone": phone,
                    "oldPassword": pass,
                    "newPassword": newPass
                },
                'type': {'act': 'editMyName'}
            }
            managedata.sendData(passData)
        }
        if (newPhone !== phone) editLocalUser('phone')
    }

    const handleVerify = () => {
        let data = {
            authentication: {
                key: utils.getToken(),
                businessToken: utils.getBusToken(),
            },
            'data': {
                "otpCode": verificationCode,
            },
            'type': {'act': 'verifyNewPhone'}
        }
        managedata.sendData(data, false, updateAll)
    };

    return (
        <motion.div
            initial={{opacity: 0, scale: 3}}
            animate={{opacity: 1, scale: 1}}
            exit={{opacity: 0, scale: 1}}
            className="w-full max-w-lg mx-auto"
        >
            <div className="rounded-2xl shadow-lg bg-white p-6 space-y-5">
                <h2 className="text-2xl font-semibold text-center">{utils.useLang('EDIT_USER')}</h2>

                {step === 'edit' && (
                    <>
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div>
                                <img src={IconProfile} alt={'profile pic'}/>
                            </div>
                            <div>
                                <label
                                    className="block text-sm text-gray-600 mb-1">{utils.useLang('FIRST_NAME')}</label>
                                <input
                                    className="w-full border rounded px-3 py-2"
                                    value={fName}
                                    onChange={(e) => setFname( e.target.value)}/>
                            </div>
                            <div>
                                <label
                                    className="block text-sm text-gray-600 mb-1">{utils.useLang('LAST_NAME')}</label>
                                <input
                                    className="w-full border rounded px-3 py-2"
                                    value={lName}
                                    onChange={(e) => setLName( e.target.value)}/>
                            </div>
                            <div className="sm:col-span-2">
                                <label className="block text-sm text-gray-600 mb-1">{utils.useLang('EMAIL')}</label>
                                <input
                                    disabled
                                    type="email"
                                    className="w-full border rounded px-3 py-2"
                                    value={'test@example.com'}/>
                            </div>
                            <div className="sm:col-span-2 flex items-end gap-2">
                                <div className="flex-1">
                                    <label
                                        className="block text-sm text-gray-600 mb-1">{utils.useLang('PHONE_NUMBER')}</label>
                                    <input
                                        className="w-full border rounded px-3 py-2"
                                        value={newPhone}
                                        onChange={(e) => setNewPhone(e.target.value)}/>
                                </div>
                            </div>
                            <div className="sm:col-span-2 flex items-end gap-2">
                                <div className="flex-1">
                                    <label
                                        className="block text-sm text-gray-600 mb-1">{utils.useLang('OLD_PASS')}</label>
                                    <input
                                        type="password"
                                        className="w-full border rounded px-3 py-2"
                                        value={pass}
                                        placeholder={utils.useLang('OLD_PASS')}
                                        onChange={(e) => setPass(e.target.value)}/>
                                    <label
                                        className="block text-sm text-gray-600 mb-1">{utils.useLang('PASS')}</label>
                                    <input
                                        type="password"
                                        className="w-full border rounded px-3 py-2"
                                        value={newPass}
                                        onChange={(e) => setNewPass(e.target.value)}/>
                                </div>
                            </div>
                        </div>

                        <div className="flex justify-between pt-6">
                            <button
                                className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
                                onClick={onSave}>
                                {utils.useLang('SAVE_DETAILS')}
                            </button>
                        </div>
                    </>
                )}

                {step === 'verify' && (
                    <div className="space-y-4">
                        <p className="text-sm text-gray-700 text-center">
                            {utils.useLang('ENTER_CODE_SMS')}
                        </p>
                        <input
                            type="text"
                            maxLength={6}
                            value={verificationCode}
                            onChange={(e) => setVerificationCode(e.target.value)}
                            className="w-full border rounded px-4 py-2 text-center tracking-widest text-xl"/>
                        <div className="flex justify-between pt-4">
                            <button
                                className="px-4 py-2 bg-gray-100 rounded hover:bg-gray-200"
                                onClick={() => setStep('edit')}>
                                {utils.useLang('BACK')}
                            </button>
                            <button
                                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                                onClick={handleVerify}>
                                {utils.useLang('SEND')}
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </motion.div>
    );
};

export default GeneralProfile;
